export const defaultDayHighlightSkin = 'standard';